import React, { useEffect, useState } from "react";

const FIRST_PART_REPLACEMENT = "$query-param-{";
const LAST_PART_REPLACEMENT = "}";

export interface IProps {
  key: number;
  match: string;
}

const NumberFormatter = new Intl.NumberFormat("en-GB");

const getFormattedParam = (queryParam: string) => {
  const urlParams = new URLSearchParams(window.location.search);
  const value = urlParams.get(queryParam) || "";
  const formattedValue = value === "" || Number.isNaN(Number(value)) ? value : NumberFormatter.format(Number(value));
  return formattedValue;
};

export const QueryParam: React.FunctionComponent<IProps> = ({ key, match }) => {
  const [queryText, setQueryText] = useState("");

  useEffect(() => {
    const queryParam = match.substring(FIRST_PART_REPLACEMENT.length, match.length - LAST_PART_REPLACEMENT.length);
    const formattedValue = getFormattedParam(queryParam);
    setQueryText(formattedValue);
  }, []);

  return (
    <span key={key}>{queryText}</span>
  );
};
